// 个人中心页面
const PersonalData = () => import('@/pages/personalCenter/personalData.vue')
const ChangePhone = () => import('@/pages/personalCenter/changePhone.vue')
const ChangePaypwd = () => import('@/pages/personalCenter/changePaypwd.vue')
const ChangePwd = () => import('@/pages/personalCenter/changePwd.vue')
const PersonalCenter = () => import('@/pages/personalCenter.vue')
const ProjectNews = () => import('@/pages/personalCenter/projectNews.vue')
const ProjectFunds = () => import('@/pages/personalCenter/projectFunds.vue')
const SystemNews = () => import('@/pages/personalCenter/systemNews.vue')
const ReceivedComments = () => import('@/pages/personalCenter/receivedComments.vue')
const ReceivedPraise = () => import('@/pages/personalCenter/receivedPraise.vue')
const MyComments = () => import('@/pages/personalCenter/myComments.vue')
const MyCoin = () => import('@/pages/personalCenter/myCoin.vue')
const MyConcerns = () => import('@/pages/personalCenter/myConcerns.vue')
const MyPost = () => import('@/pages/personalCenter/myPost.vue')
const PurchasedResponse = () => import('@/pages/personalCenter/purchasedResponse.vue')
const MyAnswer = () => import('@/pages/personalCenter/myAnswer.vue')
const AllStandard = () => import('@/pages/personalCenter/allStandard.vue')
const WeeklyPlan = () => import('@/pages/personalCenter/weeklyPlan.vue')

export default [

  {
    path: '/personalCenter/personalData',
    name: '个人资料',
    component: PersonalData,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/changePhone',
    name: '修改手机号',
    component: ChangePhone,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/changePaypwd',
    name: '修改支付密码',
    component: ChangePaypwd,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/changePwd',
    name: '修改密码',
    component: ChangePwd,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter',
    name: '个人中心',
    component: PersonalCenter,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/projectNews',
    name: '项目消息',
    component: ProjectNews,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/projectFunds',
    name: '项目款项',
    component: ProjectFunds,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/myCoin',
    name: '我的金币',
    component: MyCoin,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/systemNews',
    name: '系统消息',
    component: SystemNews,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/receivedComments',
    name: '收到的评论',
    component: ReceivedComments,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/receivedPraise',
    name: '收到的评论',
    component: ReceivedPraise,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/myComments',
    name: '我的评论',
    component: MyComments,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/myConcerns',
    name: '我的关注',
    component: MyConcerns,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/myPost',
    name: '我的发布',
    component: MyPost,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/purchasedResponse',
    name: '已购回答',
    component: PurchasedResponse,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/myAnswer',
    name: '我的回答',
    component: MyAnswer,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/allStandard',
    name: '施工标准',
    component: AllStandard,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: true,
    }
  },
  {
    path: '/personalCenter/weeklyPlan',
    name: '施工标准',
    component: WeeklyPlan,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },


]


// WEBPACK FOOTER //
// ./src/router/modules/personalRouter.js